(function () {

    'use strict';

    class BarCodeScanDialogCtrl {
        constructor($mdDialog, $translate, system) {
            this.system = system;
            this.$mdDialog = $mdDialog;
            this.dateFormat = this.system['date_format'].js;
            this.cancel = $mdDialog.cancel;
        }

        static get $inject() {
            return ["$mdDialog", "$translate", "system"];
        }

        $onInit() {
            this.codes = [];
        }

        submit() {
            this.$mdDialog.hide(this.codes);
        }
    }

    module.exports = {
        template: require("../views/bar-code-scan.tpl.html"),
        controllerAs: "vm",
        controller: BarCodeScanDialogCtrl,
        parent: $(document.body),
        clickOutsideToClose: false,
        bindToController: true,
        multiple: true,
        focusOnOpen: false

    }

})();